import * as React from 'react';
import styled from 'styled-components';

const Breadcrumb = styled.div``;

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  > * {
    &:last-child {
      flex: 1;
      overflow: hidden;
    }
  }
`;

interface BreadcrumbGroupPrimaryProps {
  breadcrumbs?: {
    key?: string;
    render?: () => React.ReactNode;
  }[];
}

export const BreadcrumbGroupLayout = (props: BreadcrumbGroupPrimaryProps) => {
  const { breadcrumbs } = props;

  return (
    <Container className="breadcrumb-group-primary">
      {breadcrumbs?.map(({ key, render }) => (
        <Breadcrumb key={key}>
          {render?.()}
        </Breadcrumb>
      ))}
    </Container>
  );
};
